// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"536":"accb8295","932":"54c6441f"}[chunkId] + ".chunk.css";
};